// extracted by mini-css-extract-plugin
export default {"container":"columns_container__2Fhrq","column":"columns_column__4lMJI"};